import { useMemo } from 'react';
import { createEditor } from 'slate';
import { withPlate } from '@udecode/plate';

import withPaste from 'components/text_editor_new/lib/with_paste';

export default function useEditorWithDecorators(plugins, { editorId, addTrailingParagraphAfterTable = false }) {
  const editor = useMemo(() => {
    const baseEditor = withPlate(createEditor(), { plugins, id: editorId });
    return withPaste(baseEditor, { addTrailingParagraphAfterTable });
  }, [editorId, plugins, addTrailingParagraphAfterTable]);

  return editor;
}
